import styled, { css } from "../../../styled/index";
import { shadeAlternate } from "../../../styled/helpers";
export const TabSelectComponent = styled("div") `
  position: relative;
  overflow: hidden;
  background: ${({ background }) => background};
  user-select: none;
  width: 100%;
  height: ${({ hasBorder }) => hasBorder ? 44 : 42}px;
  z-index: ${({ theme }) => theme.slide_panel.zindex};
`;
export const TabSelectControlComponent = styled("div") `
  z-index: 1;
  display: ${({ hide }) => hide ? "none" : "flex"};
  justify-content: center;
  align-items: center;
  background: ${({ background }) => background};
  position: absolute;
  height: 42px;
  width: 32px;
  cursor: pointer;
  ${({ side, background }) => side === "left" ? css `
    left: 0;
    border-right: 1px solid ${shadeAlternate(0.1, background)};
  ` : css `
    right: 0;
    border-left: 1px solid ${shadeAlternate(0.1, background)};
  `};
`;
export const TabSelectHighlightComponent = styled("div") `
  position: absolute;
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
  transition: all 0.3s ease;
  top: 40px;
  transform: translateX(${({ startPosition }) => startPosition}px);
  width: ${({ width }) => width}px;
`;
export const TabSelectContentComponent = styled("div") `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  line-height: 0;
  transition: 0.3s all;
  transform: translateX(${({ position }) => position}px);
`;
export const TabSelectOptionsComponent = styled("div") `
  cursor: pointer;
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  transition: 0.3s all;
`;
export const TabNameText = styled("p") `
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 300px;
	font-size: 14px;
`;
export const TabSelectOptionComponent = styled("div") `
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  padding: 0 12px;
  height: 39px;
  visibility: ${({ hidden }) => hidden ? "hidden" : "visible"};
  white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
//# sourceMappingURL=components.js.map